import * as React from 'react';

import _ from 'lodash';

import { TextInput } from '@coursera/coursera-ui';

import { USER_NAME_REGEX_PATTERN } from 'bundles/user-account/common/constants';

import _t from 'i18n!nls/user-account';

type Props = {
  value: string;
  style?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  defaultValue?: string;
  pattern?: string;
  title?: string;
  autoFocus?: boolean;
  placeholder?: string;
  onChange: (x0: React.ChangeEvent<HTMLInputElement>) => void;
};

function getTranslations(): { [name: string]: string } {
  return {
    FULL_NAME: _t('Full name'),
    FULL_NAME_REQ_VALIDATION: _t('Please enter a name'),
  };
}

export default function NameField({ value, style, inputStyle, pattern, ...rest }: Props) {
  const _T = getTranslations();

  return (
    <TextInput
      name="name"
      componentId={_.uniqueId('nameInput_')}
      label={_T.FULL_NAME}
      placeholder={_T.FULL_NAME}
      value={value}
      style={style}
      nativeHtmlAttributes={{
        required: true,
        pattern: pattern || USER_NAME_REGEX_PATTERN,
        'data-e2e': 'name-field',
        onInvalid: (event) => {
          const target = event.target as HTMLInputElement;

          const { value: inputText } = target;
          if (!inputText) {
            target.setCustomValidity(_T.FULL_NAME_REQ_VALIDATION);
          }
        },
        onInput: (event) => (event.target as HTMLInputElement).setCustomValidity(''),
        style: inputStyle,
        ...rest,
      }}
    />
  );
}
